export const GET_BASIC_SETTINGS = 'GET_BASIC_SETTINGS';

export function basicSettings(data, callback) {
  return {
    type: GET_BASIC_SETTINGS,
    payload: {data, callback},
  }; 
}